<template>
  <div>
    <validation-observer ref="legalEntityForm">

      <b-form @submit.prevent="saveLegalEntityForm">

        <div class="vx-row">
          <div class="vx-col sm:w-1/3 w-full mb-2">

            <b-form-group
                label="CNPJ"
                label-for="cnpj"
              >
              <validation-provider
                #default="{ errors }"
                name="cnpj"
              >
                <b-form-input
                  id="cnpj"
                  v-model="legalEntity.cnpj"
                  :state="errors.length > 0 ? false:null"
                  name="register-cnpj"
                  v-mask="['##.###.###/####-##']"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

          </div>

          <div class="vx-col sm:w-2/3 w-full mb-2">

            <b-form-group
                label="Razão Social"
                label-for="company_name"
              >
              <validation-provider
                #default="{ errors }"
                name="Razão Social"
                rules="required"
              >
                <b-form-input
                  id="company_name"
                  v-model="legalEntity.company_name"
                  :state="errors.length > 0 ? false:null"
                  name="company_name"
                  class="required"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- <span
              class="text-danger text-sm"
              v-show="errors.has('company_name')"
            >{{ errors.first('company_name') }}</span> -->
          </div>

          <!-- <div class="vx-col sm:w-1/3 w-full mb-2">
            <b-form-checkbox v-model="legalEntity.own_place" class="mt-6">Sede própria</b-form-checkbox>
            <span
              class="text-danger text-sm"
              v-show="errors.has('company_name')"
            >{{ errors.first('company_name') }}</span>
          </div> -->
        </div>

        <div class="vx-row mb-2">
          <div class="vx-col sm:w-1/3 w-full">
              <b-form-group
                  label="Nome Fantasia"
                  label-for="trading_name"
                >
                <validation-provider
                  #default="{ errors }"
                  name="Nome Fantasia"
                  rules="required"
                >
                  <b-form-input
                    id="trading_name"
                    v-model="legalEntity.trading_name"
                    :state="errors.length > 0 ? false:null"
                    name="trading_name"
                    class="required"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
          </div>
          <div class="vx-col sm:w-1/5 w-full">
            <b-form-group
                label="Sigla"
                label-for="short_name">
              <validation-provider
                #default="{ errors }"
                name="short_name">
                <b-form-input
                  id="short_name"
                  v-model="legalEntity.short_name"
                  :state="errors.length > 0 ? false:null"
                  name="short_name"/>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </div>
          <div class="vx-col sm:w-1/5 w-full">
              <b-form-group
                  label="Número Interno"
                  label-for="trading_name">
                <validation-provider
                  #default="{ errors }"
                  name="internal_number">
                  <b-form-input
                    id="internal_number"
                    v-model="legalEntity.internal_number"
                    :state="errors.length > 0 ? false:null"
                    name="internal_number"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            <!-- <span
              class="text-danger text-sm"
              v-show="errors.has('trading_name')"
            >{{ errors.first('trading_name') }}</span> -->
          </div>
          <div class="vx-col sm:w-1/5 w-full">
              <b-form-group
                label="Ativo"
                label-for="active">
                <validation-provider
                  #default="{ errors }"
                  name="outsourced">
                  <b-form-checkbox
                    v-model="legalEntity.status"
                    class="mr-0 mt-50"
                    name="active"
                    switch
                    inline
                    value="A"
                    unchecked-value="I"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col sm:w-1/1 w-full mb-2">

            <b-form-group
                label="Mantenedora"
                label-for="main_office_id">
              <validation-provider
                #default="{ errors }"
                name="main_office_id">
                <v-select
                  v-model="mainOffice"
                  :options="mainOfficeList"
                  label="trading_name">
                  <div slot="no-options">Nenhum registro encontrado!</div>
                </v-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

          </div>
        </div>

        <!-- <div class="vx-row">
          <div class="vx-col sm:w-1/3 w-full mb-2">
            <vs-input
              class="w-full input-text-align-right"
              label="Faturamento Mensal"
              ref="monthly_income"
              v-model.lazy="legalEntity.monthly_income"
              v-money="money"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('monthly_income')"
            >{{ errors.first('monthly_income') }}</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full mb-2">
            <vs-input
              class="w-full input-text-align-right"
              label="Valor Patrimonial"
              ref="equity_value"
              v-model="legalEntity.equity_value"
              v-money="money"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('equity_value')"
            >{{ errors.first('equity_value') }}</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full mb-2">
            <vs-input
              class="w-full"
              label="Tempo Sede Atual (meses)"
              v-model="legalEntity.time_in_place"
              v-mask="['####']"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('time_in_place')"
            >{{ errors.first('time_in_place') }}</span>
          </div>
        </div> -->

        <div class="vx-row mt-2 mb-2" v-if="!isComplement">
          <div class="vx-col w-full flex justify-end">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2 float-right"
              :disabled="!validateForm"
              type="submit">
              Salvar
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              class="mr-1 float-right"
              @click="addNewUnit"
              v-if="buttonNewUnitShow">
                {{$t('new_unit')}}
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              class="mr-1 float-right"
              @click="showImportModal = true"
              v-if="showButtonImportUnit">
                {{$t('action.import_unit')}}
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-secondary"
              @click="cancel"
              class="float-right">
              Voltar
            </b-button>
          </div>
        </div>

      </b-form>

    </validation-observer>

    <div class="vx-row" v-if="legalEntity.id !== null">
      <div class="vx-col sm:w-1/1 w-full mb-2">
          <LegalEntitySponsor
            :key="legalEntity"
            :services="services"
            :legalEntity="legalEntity">
          </LegalEntitySponsor>
      </div>
    </div>

    <vs-popup title="Importar Unidades" :active.sync="showImportModal">
      <ImportExcel
        :onSuccess="onImportUnitSuccess"
        templateMessage="Clique aqui para baixar um modelo para <br/> o preenchimento de importação de pessoa jurídica."
        accept=".xlsx, .xls">
      </ImportExcel>
    </vs-popup>

  </div>
</template>


<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BForm, BButton, BFormInput, BFormGroup, BFormRadioGroup, BFormCheckbox
} from 'bootstrap-vue'
import { required, email } from '@validations'
import vSelect from 'vue-select'
import { VMoney } from 'v-money'
import ImportExcel from '@/components/excel/ImportExcel'
import LegalEntityService from '@/services/api/LegalEntityService'
import LegalEntitySponsor from './LegalEntitySponsor.vue'

export default {
  components: {
    LegalEntitySponsor,
    vSelect,
    // BSV
    BForm,
    BButton,
    BFormInput,
    BFormGroup,
    BFormRadioGroup,
    BFormCheckbox,
    // validations
    ValidationProvider,
    ValidationObserver,
    ImportExcel,
  },
  directives: { money: VMoney },
  props: {
    legalEntityId: {
      type: Number,
      default: null
    },
    simpleCreation: {
      type: Boolean,
      default: false
    },
    services: {
      type: Object,
      default: null
    },
    isComplement: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    money: {
      decimal: ',',
      thousands: '.',
      prefix: 'R$ ',
      precision: 2,
      masked: false
    },
    federationUnit: null,
    federationUnitList: [],
    legalEntity: {
      id: null,
      cnpj: null,
      trading_name: null,
      company_name: null,
      own_place: null,
      monthly_income: null,
      equity_value: null,
      time_in_place: null,
      sponsors: [],
      main_office_id: null,
      mainOffice: null,
      status: null,
      internal_number: null,
      short_name: null,
    },
    cityList: [],
    mainOfficeList: [],
    mainOffice: null,
    showSpousePopup: false,
    legalEntityService: null,
    showImportModal: false,

    // validation rules
    required,
    email,
  }),
  computed: {
    validateForm() {
      return (
        !this.isEmpty(this.legalEntity.trading_name) &&
        !this.isEmpty(this.legalEntity.company_name)
      )
    },
    buttonNewUnitShow(){
      return !this.isEmpty(_.get(this.legalEntity, 'id')) && !this.isEmpty(_.get(this.legalEntity, 'main_office_id'))
    },
    showButtonImportUnit(){
      return !this.isEmpty(_.get(this.legalEntity, 'id'))
    },
    importExampleUrl() {
      return `${process.env.VUE_APP_API_BASE_URL}/medias/public/download/sca-modelo-importacao-pessoa-juridica.xlsx`
    },
  },
  methods: {
    saveLegalEntityForm() {

      this.$refs.legalEntityForm.validate().then(success => {

        if (success) {

          this.clearErrors(this.$refs.legalEntityForm)
          this.$vs.loading()

          const cnpj = !this.isEmpty(this.legalEntity.cnpj)
            ? this.clearDashDots(this.legalEntity.cnpj).replace('/', '')
            : ''

          const legalEntity = this.$store.getters['legalEntity/legalEntity']
          const peopleId = legalEntity ? _.get(this.legalEntity, 'people.id') ? legalEntity.people.id: null : null
          const isCreate = peopleId === null
          //new unit in form legal entity, with add new unit, if case
          const mainOfficeId = this.mainOffice
            ? this.mainOffice.id
            : this.legalEntity.main_office_id || this.$route.query.param_main_office_id

          const params = {
              people_id: peopleId,
              id: this.legalEntity.id,
              cnpj,
              trading_name: this.legalEntity.trading_name,
              company_name: this.legalEntity.company_name,
              own_place: this.legalEntity.own_place,
              monthly_income: this.legalEntity.monthly_income,
              equity_value: this.legalEntity.equity_value,
              time_in_place: this.legalEntity.time_in_place,
              main_office_id: mainOfficeId ? mainOfficeId : '',
              status: this.legalEntity.status,
              internal_number: this.legalEntity.internal_number,
              short_name: this.legalEntity.short_name,
            }
          this.services.legalEntityService.createOrUpdate(params).then(
              data => {

                this.legalEntity.id = data.id
                this.$vs.loading.close()
                this.notifySuccess(this.$vs)

                if (!this.isComplement) {
                  if (isCreate) {
                    if (this.simpleCreation) {
                      this.$root.$emit('legalEntityCreated', data)
                      this.clearErrors(this.$refs.legalEntityForm)
                    } else {
                      this.$root.$emit('legalEntityCreated', data)
                      this.$router.push(`/people/legal_entities/${data.id}/edit`)
                    }
                  }
                } else {
                  this.$root.$emit('legalEntityCreated', data)
                }

                if(this.legalEntityId){
                  this.$store.commit('legalEntity/UPDATE_LEGAL_ENTITY', data)
                  this.$root.$emit('legalEntityUpdated')
                }
              },
              error => {
                this.$vs.loading.close()
                this.showErrors(this.$refs.legalEntityForm, error)
              }
            )
        }
      })
    },
    cancel() {
      if (this.simpleCreation) {
        this.$root.$emit('legalEntityClosed')
        this.clearFields()
        this.clearErrors(this.$refs.form)
      } else {
        this.$store.commit('legalEntity/UPDATE_LEGAL_ENTITY', null)
        this.$router.push('/people/legal_entities')
      }
    },
    getAllLegalEntities() {
      this.services.legalEntityService.all().then(data => {
        this.mainOfficeList = data

        if (this.legalEntity.main_office_id) {
          this.mainOffice = this.mainOfficeList.find(element => element.id === this.legalEntity.main_office_id) || null
        }

      })
    },
    addNewUnit() {
      var mainOfficeId = this.mainOffice ? this.mainOffice.id : null
      mainOfficeId = mainOfficeId ? mainOfficeId : this.legalEntity.main_office_id
      mainOfficeId = mainOfficeId ? mainOfficeId : ''

      this.clearFieldsCompleteFromAddNewUnit()
      this.clearErrors(this.$refs.form)
      this.$store.commit('legalEntity/UPDATE_LEGAL_ENTITY', null)
      this.$router.push('/people/legal_entities/create?param_main_office_id='+mainOfficeId)
    },
    clearFieldsCompleteFromAddNewUnit() {
      this.legalEntity.id = null
      this.legalEntity.cnpj = null
      this.legalEntity.trading_name = null
      this.legalEntity.company_name = null
      this.legalEntity.own_place = null
      this.legalEntity.monthly_income = null
      this.legalEntity.equity_value = null
      this.legalEntity.time_in_place = null
      this.legalEntity.sponsors = []
      //this.legalEntity.main_office_id = null
      //this.legalEntity.mainOffice = null
      //this.main_office_id = null
      this.legalEntity.status = 'A'
      this.legalEntity.internal_number = null,
      this.legalEntity.short_name = null
    },
    onImportUnitSuccess(data) {
      this.legalEntityService.importLegalEntityUnit(this.legalEntityId, data).then(
        data => {
          this.notifySuccess(this.$vs, 'Importação realizada com sucesso.')
          this.showImportModal = false
        },
        error => {
          this.notifyErrors(this.$vs, error, 5000)
        }
      ).finally(() => {this.$vs.loading.close()})
    },
  },
  created() {

  },
  beforeMount() {
    this.legalEntityService = LegalEntityService.build(this.$vs)
  },
  mounted() {

    if (this.legalEntityId !== null) {
      this.$vs.loading()
      this.services.legalEntityService.read(this.legalEntityId).then(legalEntity => {

          this.legalEntity.id = legalEntity.id

          this.legalEntity.cnpj = legalEntity.cnpj
          this.legalEntity.trading_name = legalEntity.trading_name
          this.legalEntity.company_name = legalEntity.company_name
          this.legalEntity.own_place = legalEntity.own_place
          this.legalEntity.time_in_place = legalEntity.time_in_place
          this.legalEntity.sponsors = legalEntity.sponsors
          this.legalEntity.main_office_id = legalEntity.main_office_id
          this.legalEntity.status = legalEntity.status ? legalEntity.status : 'A'
          this.legalEntity.internal_number = legalEntity.internal_number
          this.legalEntity.short_name = legalEntity.short_name
          this.legalEntity.legal_entity_form_lgpd = legalEntity.legal_entity_form_lgpd

          // Workaround to fix Vuetify input with v-money directive
          // this.$refs.monthly_income.$el.getElementsByTagName('input')[0].value =
          //   legalEntity.monthly_income
          // this.$refs.equity_value.$el.getElementsByTagName('input')[0].value =
          //   legalEntity.equity_value

          this.$store.dispatch('common/fetchFederationUnit').then(federationUnitList => {
              this.federationUnitList = federationUnitList
              this.$root.$emit('federationUnitUpdated')
            })

          this.$store.commit('legalEntity/UPDATE_LEGAL_ENTITY', legalEntity)

          this.$root.$emit('legalEntityUpdated')

          this.getAllLegalEntities()

          this.$vs.loading.close()
        })
    } else {
      this.getAllLegalEntities()
      this.$store
        .dispatch('common/fetchFederationUnit')
        .then(federationUnitList => {
          this.federationUnitList = federationUnitList
          this.$root.$emit('federationUnitUpdated')
        })
    }
    if(this.isEmpty(_.get(this.legalEntity, 'status'))){
      this.legalEntity.status = 'A'
    }
  }
}
</script>
